module.exports = __webpack_public_path__ + "fonts/Lato-Heavy.c9cbbdc3.woff2";